<template>
  <div v-if="vg_modal">
    <div class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-card is-small checkbox-dark">
        <header class="modal-card-head">
          <button class="delete" aria-label="close" @click="closeModal()"></button>
          <p class="modal-card-title has-text-black" v-if="screen == 1">Sign In</p>
          <p class="modal-card-title has-text-black" v-if="screen == 2">Code Verification</p>
        </header>
        <section class="modal-card-body ph20">

          <div class="social-login" v-if="screen == 1">
            <div class="social-icons-wrap is-flex is-flex-column">
              <div id="buttonDiv"></div>
              <a href="#" class="social-login-signup-wrapper mb10" @click.prevent="loginWithGoogle">
                <div class="social-login-section">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="20" viewBox="0 0 18 18" aria-hidden="true"><title>Google</title><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"></path><path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"></path></g></svg>
                  <span class="letter-space-0_5 is-size-14">SIGN IN WITH GOOGLE</span>
                </div>
              </a>
              <a href="#" class="social-login-signup-wrapper" @click.prevent="loginWithFacebook">
                <div class="social-login-section">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 24 24"><path  fill="#4285F4" d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
                  <span class="letter-space-0_5 is-size-14">SIGN IN WITH FACEBOOK</span>
                </div>
              </a>
            </div>
            <div class="mt20 mb20 is-size-14"><span>Or continue with:</span></div>
          </div>
        
          <ValidationObserver ref="val_observer_loginform">
          <form data-vv-scope="loginform" @submit.prevent="getLoginToken()" ref="loginform" v-if="screen == 1">
            <div class="signup-modal-fields">
              <div class="field">
                <div class="control">
                  <validation-provider :name="phone_email_rule_text" ref="login_email" :rules="phone_email_rules">
                    <template #default="{ errors }">
                      <input
                        class="input"
                        name="email"
                        v-model="loginForm.email"
                        type="text"
                        placeholder="Phone Number or Email"
                      />
                      <span class="validation-error">{{ errors[0] }}</span>
                    </template>
                  </validation-provider>
                </div>
              </div>
            </div>
          </form>
          </ValidationObserver>

          <ValidationObserver ref="val_observer_confirmation_form">
          <form data-vv-scope="confirmation_form" @submit.prevent="submitCode()" ref="confirmation_form" v-if="screen == 2">
            <p class="is-size-14 has-text-centered mb20 has-text-weight-semibold">{{ verification_code_sent_message }}</p>
            <div class="field-group">
              <div class="field">
                <div class="control">
                  <validation-provider name="confirmation code" ref="confirmation_code" rules="required">
                    <template #default="{ errors }">
                      <input
                        class="input"
                        name="confirmation_code"
                        v-validate="'required'"
                        v-model="confirmation_code"
                        type="text"
                        placeholder="Confirmation Code"
                      />
                      <span class="validation-error">{{ errors[0] }}</span>
                    </template>
                  </validation-provider>
                </div>
              </div>
            </div>
          </form>
          </ValidationObserver>
 
          <button
            @click="resendConfirmationCode()"
            v-if="screen == 2"
            :disabled="codeResendTimer > 0"
            class="button mt20 is-large is-transparent is-full-width"
          >RESEND CODE <span v-if="codeResendTimer > 0"> &nbsp; ({{ codeResendTimer }}S)</span></button>
          
        </section>

        <footer class="modal-card-foot">
          <div class="column p0">
          <button
            @click="getLoginToken()"
            v-if="screen == 1"
            class="button is-large bg-secondary hover-opacity-7 text-white is-full-width"
          >SIGN IN</button>

          <button
            @click="submitCode()"
            v-if="screen == 2"
            class="button is-large bg-secondary hover-opacity-7 text-white is-full-width"
          >SIGN IN</button>

          <p class="text-center is-size-14 mt20 has-text-black">
            Don’t have an account? <a href="#" class="text-secondary hover-text-secondary hover-opacity-8 has-text-weight-semibold is-underlined" @click.prevent="signUpscreen()">CLICK HERE</a>
          </p>
          <p class="text-center is-size-11 mt30 text-primary">POWERED BY <img class="powered-logo" alt="logo" src="@/assets/img/logo.png" /></p>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from '@/Components/Helpers/Helpers';
import { mapGetters, mapActions } from "vuex";
import LoginApis from '@/Components/Controllers/LoginApis';
//import ForgotPasswordApis from '@/Components/Controllers/ForgotPasswordApis';
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import CartApis from '@/Components/Controllers/CartApis';
import UserApis from '@/Components/Controllers/UserApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import moment from 'moment';

export default {
  name: "SetLocationModal",
  components: {

  },
  data() {
    return {
      screen: 1,
      verification_code_sent_message: 'We sent you a confirmation code!',
      codeResendTimer: 0,
      phone_email_rule_text: 'email',
      loginForm: {
        email: '',
        platform: "web",
        app_version: "0.1"
      },
      auth_code_token: '',
      confirmation_code: '',
    };
  },

  computed: {
    phone_email_rules() {
      let rule = 'required';
      if(this.loginForm.email){
        // if first letter user type is not a number then he must be typing email
        if( isNaN(this.loginForm.email.charAt(0)) || (this.loginForm.email.indexOf('@') > 1) ){
            rule ='|email';
            this.phone_email_rule_text = 'email';
        } else {
          rule ='|phone_number|numeric';
          this.phone_email_rule_text = 'phone';
        }
      } 
      return rule;
    },
    ...mapGetters({
      vg_modal: "loginmodal/modal",
      vg_businessProfile: "businessprofile/detail", 
      vg_redirect: "loginmodal/redirect",
      vg_selectedStore: "location/selected", 
      vg_cartId: "cart/id",
      vg_cartItems: "cart/cartItems",
      vg_cartId: "cart/id",
      vg_pendingItemOnCart: "cart/pendingItem",
      vg_userId: "getLoggedInUserId",
      vg_businessLoyality: "businessprofile/businessLoyality",
      vg_outOfStockPendingItem: "outofstocksubscriptions/pendingItem",
      vg_checkoutOrderType: "checkout/ordertype",
    })
  },

  async mounted() {
    this.va_spinner(false);
    this.va_setModal(false);
    await Helpers.loadFacebookSDK();
    await Helpers.initFacebook(this.vg_userId);
  },

  watch:{
    vg_modal() {
      this.screen = 1;
    },
    'loginForm.email'(val){
      this.loginForm.email = val.toLowerCase();
      // if type is phone do not let user type more than 10 letters
      if(this.phone_email_rule_text == 'phone'){
        let newval = val.trim();
        newval = newval.replaceAll(/\s/g,'')
        newval = newval.slice(0,10)
        this.loginForm.email = newval;
      } else {
        this.loginForm.email = val.replaceAll(/\s/g,'').trim();
      }
    },
  },

  methods: {
    /**
     * Get login token
     */
    async getLoginToken() {

      let validation = await Helpers.validateRefs(this, [
        "login_email",
      ]);
      if (!validation) {
       return;
      }

      // now check what value user passed
      let obj = {};
      if(this.phone_email_rule_text == 'phone'){
        obj.phone = this.loginForm.email;
      } else {
        obj.email = this.loginForm.email;
      }
      // Extra need to pass
      obj.business_id = this.vg_businessProfile.id;
      obj.business_name = this.vg_businessProfile.name;
      obj.business_slug = this.$route.params.business_slug;
      obj.logo_url = (this.vg_businessProfile && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) ? this.vg_businessProfile.branding.logo_url : '';
      obj.location_id = this.vg_selectedStore.id ? this.vg_selectedStore.id : '';
      obj.location_slug = this.vg_selectedStore.slug ? this.vg_selectedStore.slug : '';

      this.va_spinner(true);
      let res = await LoginApis.loginViaEmailOrPhone(obj);
      this.va_spinner(false);
      if(res.status == 200){
        if(res.data.msg){
          this.verification_code_sent_message = res.data.msg;
        }
        this.$refs.val_observer_loginform.reset();
        this.$refs.val_observer_confirmation_form.reset();
        this.screen = 2;
        this.auth_code_token = res.data.payload.auth_code_token;
        this.initConfirmationTiming();
      } else {
        this.va_snackbar({
          type: 'warning',
          message: res.response ? res.response.data.msg : 'Please try again later.',
        });
      }
    },

    /**
     * Init token time
     */
    initConfirmationTiming() {
      this.codeResendTimer = 60;
      let timer = setInterval(() => {
        this.codeResendTimer = (this.codeResendTimer - 1)
        if(this.codeResendTimer == 0){
          clearInterval(timer);
        }
      }, 1000)
    },

    /**
     * Resend Confirmation code
     */
    async resendConfirmationCode() {
      // now check what value user passed
      let obj = {};
      if(this.phone_email_rule_text == 'phone'){
        obj.phone = this.loginForm.email;
      } else {
        obj.email = this.loginForm.email;
      }
      // Extra need to pass
      obj.business_id = this.vg_businessProfile.id;
      obj.business_name = this.vg_businessProfile.name;
      obj.business_slug = this.$route.params.business_slug;
      obj.logo_url = (this.vg_businessProfile && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) ? this.vg_businessProfile.branding.logo_url : '';
      obj.location_id = this.vg_selectedStore.id ? this.vg_selectedStore.id : '';
      obj.location_slug = this.vg_selectedStore.slug ? this.vg_selectedStore.slug : '';
      
      this.va_spinner(true);
      let res = await LoginApis.loginViaEmailOrPhone(obj);
      this.va_spinner(false);
      if(res.status == 200){
        this.$refs.val_observer_loginform.reset();
        this.$refs.val_observer_confirmation_form.reset();
        this.auth_code_token = res.data.payload.auth_code_token;
        this.initConfirmationTiming();
      } else {
        this.va_snackbar({
          type: 'warning',
          message: res.response.data.msg,
        });
      }
    },

    /**
     * Submit code to get login
     */
    async submitCode() {
      let validation = await Helpers.validateRefs(this, [
        "confirmation_code",
      ]);
      if (!validation) {
       return;
      }
      this.va_spinner(true);
      let res = await LoginApis.verifyPhoneOrEmailLoginToken({
        auth_code_token: this.auth_code_token,
        auth_code: this.confirmation_code,
      });
      if(res.status == 200) {
        await this.setLoginSuccessUserData(res);
      }
      this.va_spinner(false);
      this.va_snackbar({
        type: res.status == 200 ? 'success' : 'warning',
        message: res.status == 200 ? res.data.msg : res.response.data.msg,
      });
    },
  
    /**
     * Login with google
     */
    async loginWithFacebook() {
      const self = this;
      //self.va_spinner(true);
      window.FB.login(async function(response) {
        if (response.authResponse) {
          //let fbUserData = await Helpers.getfacebookUserInfo();
          let res = await self.loginWithSocial({
            social_type: 'facebook',
            access_token: response.authResponse.accessToken
          });
          if(res.status == 200) {
            await self.setLoginSuccessUserData(res);
            self.va_spinner(false);
          } else if (res.response && (res.response.status == 403) ){
            self.va_spinner(false);
            // before we pass data to signup lets get all the data 
            await window.FB.api('/me', { 
              locale: 'en_US', 
              fields: 'id,first_name,last_name,email,link,gender,locale' 
            }, function(fbData){
              self.va_spinner(false);
              if (fbData.id) {
                let obj = {};
                obj.first_name = fbData.first_name;
                obj.last_name = fbData.last_name;
                obj.email = fbData.email;
                obj.social_type = 'facebook';
                obj.social_id = response.authResponse.userID;
                self.passDetailToSignup(obj)
              } else {
                self.va_spinner(false);
                self.va_snackbar({
                  type: 'warning',
                  message: 'Unable to fetch facebook detail.',
                });
              }
            }); 
          } else {
            // First remove Fb token that has been set
            // Helpers.removeFbCookeFromLocal();
          }
             
          // Show message on success
          if(res.status == 200){
            self.va_snackbar({
              type: res.status == 200 ? 'success' : 'warning',
              message: res.status == 200 ? res.data.msg : res.response.data.msg,
            });
          }
          
        } else {
          self.va_spinner(false);
          // self.va_snackbar({
          //   type: 'warning',
          //   message: 'User cancelled login or did not fully authorize.',
          // });
        }
      }, { 
        scope: 'email'
      });
      return false;
    },


    /**
     * Login with google
     */
    async loginWithGoogle () {
      const self = this;
      this.va_spinner(true);
      this.$gAuth
        .signIn()
        .then( async (GoogleUser) => {
          let googleResponse = GoogleUser.getAuthResponse();
          let res = await self.loginWithSocial({
            social_type: 'google',
            access_token: googleResponse.access_token
          });
       
          if(res.status == 200){
            await this.setLoginSuccessUserData(res);
          } else if (res.response && (res.response.status == 403) ){
              let obj = {};
              let googleProfile = GoogleUser.getBasicProfile();
              obj.first_name = googleProfile.getGivenName();
              obj.last_name = googleProfile.getFamilyName();
              obj.email = googleProfile.getEmail();
              obj.social_type = 'google';
              obj.social_id = GoogleUser.getId();
              self.passDetailToSignup(obj)
          }

          // Throw message only if error is not 404
          if(res.status == 200){
            this.va_snackbar({
              type: res.status == 200 ? 'success' : 'warning',
              message: res.status == 200 ? res.data.msg : res.response.data.msg,
            });
          }
          
          this.va_spinner(false);
        })
        .catch(error => {
          this.va_spinner(false);
          console.log('error', error)
        })
    },

    /**
     * Login with social
     */
    async loginWithSocial(data){
      return await LoginApis.loginWithSocial(data);
    },
    
    /**
     * Login
     */
    async login() {
      let validation = await Helpers.validateRefs(this, [
        "login_email",
      ]);
      if (validation) {
        this.va_spinner(true);
        let res = await LoginApis.login(this.loginForm);
        if(res.status == 200) {
          await this.setLoginSuccessUserData(res);
        }
        this.va_spinner(false);
        this.va_snackbar({
          type: res.status == 200 ? 'success' : 'warning',
          message: res.status == 200 ? res.data.msg : res.response.data.msg,
        });
        
      }
    },

    /**
     * on success login set datas
     */
    async setLoginSuccessUserData(res) {
      const self = this;
      // Push user to vbout
      await VboutApis.upsertUser(res.data.payload, this.vg_selectedStore.id);
      // If user has email_verification_status = true tag it 
      if(res.data.payload.email_verification_status){
        await VboutApis.addUserTag({
          email: res.data.payload.email,
          tagname: 'verified',
        }, this.vg_selectedStore.id);
      }
      // casl_opt_in as marketing notification
      if(res.data.payload.marketing_notification){
        await VboutApis.addUserTag({
          email: res.data.payload.email,
          tagname: 'casl_opt_in',
        }, this.vg_selectedStore.id);
      }

      // Add user location on login
      if(this.vg_selectedStore.id){
        UserApis.addUserLocation(res.data.payload.id, this.vg_selectedStore.id, this.$route.query);
      }
      
      // Reset login form 
      this.loginForm = Helpers.setObjValueEmpty(this.loginForm);
      this.$store.dispatch("SET_USER_TOKEN", res.data.payload.token);
      this.$store.dispatch("SET_USER_DETAILS", res.data.payload);
      this.$store.dispatch("SET_USER_LOGGEDIN_DATE", moment().format('YYYY-MM-DD HH:mm:ss'));
      
      // Start loyalty stuffs only if business is active
      if(this.vg_businessLoyality.id && this.vg_businessLoyality.is_active) {
        // On login if usr has no subscribe to loyalty subscribe and if yes show baloons
        let loyaltyJoinRes = await this.va_joinUserOnLoyalityProgram({
          user_id: res.data.payload.id,
          business_id: this.vg_businessProfile.id,
          referral_key: this.$route.query.referral_key ? this.$route.query.referral_key : '', // if has ref key pass it 
        })
        // For signup as login
        if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.welcome_bonus > 0) ) {
          // show loyalty bonus point for signup
          bus.$emit('loyality-signup-congratulations', {
            modal: true,
            point: loyaltyJoinRes.data.payload.welcome_bonus,
            message: "Sign in Bonus!",
          })
        }
        // Show loyalty referral point
        if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.referral_bonus > 0) ) {
          bus.$emit('loyality-referral-congratulations', {
            modal: true,
            point: loyaltyJoinRes.data.payload.referral_bonus,
            message: "A little something for being referred!",
          })
        }

        // user loyality checkin only if in_store, user logged in mean thay verified unless they verify email they cannot login
        if( (this.$route.query.in_store == 1) || (this.$route.query.in_store == 'true')){
          let userCheckInres = await UserApis.userLoyalityCheckIn(this.vg_businessProfile.id, this.vg_selectedStore.id, this.vg_selectedStore.name);
          if(userCheckInres.status == 200){
            // alert modal
            bus.$emit('loyality-checkin-congratulations', {
              modal: true,
              point: userCheckInres.data.payload.points_earned,
              message: "You've checked in!",
            })
          }
        }

        // Get user loyalty
        this.va_setUserLoyalityObj({
          user_id: res.data.payload.id, 
          business_id: this.vg_businessProfile.id
        });

      }

      // fetch order
      let orderHistory = await OrderHistoryApis.fetch(1);
      // fetch user fav location
      UserApis.fetchFavLocations();
      // fetch user fav products
      UserApis.fetchFavProducts();

      // as soon as user logged in remove guest checkout params
      this.va_setGuestLandedQueries({})
      // if we have selected store fetch that store cart items 
      if(!_.isEmpty(this.vg_selectedStore) && this.vg_selectedStore.id != ''){
        
        if(this.vg_cartItems.length == 0){
          // Fetch cart is guest doesnot have any cart
          await CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
        } else {
          // Fetch and merge guest and user cart
          await CartApis.convertGuestCartToUserCart(Helpers.getLocationCartFullUrl(this));          
        }

        // Once we got cart ask for loyalty
        if((this.$route.name == 'Checkout') && (this.$route.name == 'Cart')) {
          // if people login on checkout page when they already selected method, 
          // lets say on review tab, we need to fetch the data from selected method
          await this.va_setCartLoyalityPointsObj({
            order_receive_method: (this.$route.name == 'Checkout' && this.vg_checkoutOrderType.order_receive_method) ? this.vg_checkoutOrderType.order_receive_method : 'pickup'
          }); // watcher is on cart sidebar might help this for other pages
        }

        // After login push cart item on vbout but before that clear cart
        // First clear vbout cart
        let emptyCartRes = await VboutApis.emptyCart(this.vg_cartId, this.vg_selectedStore.id);
        // Add product one by one
        if(emptyCartRes && (emptyCartRes.status == 200) && this.vg_cartItems && this.vg_cartItems.length > 0){
          this.vg_cartItems.forEach(async (item) => {
            await VboutApis.addCartItem(item, Helpers.getLocationProductFullUrl(self, item.product_id), self.vg_selectedStore.id);
          })
        }
       
      }

      // lets see if we have any pending item for cart, if yes 
      if(!_.isEmpty(this.vg_pendingItemOnCart)) {
        // we have pending item
        bus.$emit('listen-pending-cart-item', this.vg_pendingItemOnCart);
        // once emit make it balnk
        this.va_setPendingItem({});
      }

      if(orderHistory.status == 200) {
        this.va_setAllOrders(orderHistory.data.payload);
      }
      
      this.va_spinner(false);
      this.closeModal();

      // lets vg_ if we have vg_ after login
      if(!_.isEmpty(this.$store.getters.getLoggedInUserRedirect)){
        // now lets vg_
        if(_.isEmpty(this.vg_pendingItemOnCart)) {
          this.$router.push(this.$store.getters.getLoggedInUserRedirect);
        }
      }

      // Now lets see if we are coming outofstock pending item
      if(!_.isEmpty(this.vg_outOfStockPendingItem)) {
        bus.$emit('variant-out-of-stock-notification', {
          modal: true,
          variant: this.vg_outOfStockPendingItem,
        })
      }
    },

    /**
     * Close modal
     */
    closeModal() {
      this.screen = 1;
      this.va_setModal(false);
      this.va_spinner(false);
      this.loginForm.email = '';
      this.codeResendTimer = 0;
      this.phone_email_rule_text = 'email';
      this.auth_code_token = '';
      this.confirmation_code = '';
      //this.$refs.val_observer_loginform.reset();
      //this.$refs.val_observer_confirmation_form.reset();
    },

    /**
     * NO account exist on social login so pass it to signup
     */
    passDetailToSignup(obj) {
      this.closeModal();
      bus.$emit('social-data-pass-to-signup', {
        modal: true,
        user: obj
      })
    },
    
    /**
     * get signup screen
     */
    signUpscreen() {
      this.closeModal();
      this.va_setSignupModal(true);
    },

    ...mapActions({
      // setUserNotifications: "usernotifications/setList",
      va_setModal: "loginmodal/setModal",
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      // setFavProduct: 'favouriteproducts/setList',
      va_setAllOrders: "orderhistory/setAllOrders",
      va_setSignupModal: "signupmodal/setModal",
      va_setPendingItem: "cart/setPendingItem",
      va_setGuestLandedQueries: "location/setGuestLandedQueries",
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
      va_joinUserOnLoyalityProgram: "userloyalitysubscription/joinUserOnLoyalityProgram",
      va_setCartLoyalityPointsObj: "cart/setLoyalityPointsObj",
      
    })
  }
};
</script>